<app-header [title]="'Concluder Inbox Mapping'"></app-header>
<div class="container-fluid p-0 inboxDiv">
  <div class="row">
    <div class="col-md-3 padding1rem blue-seprator borderLeft">
      <form name="actionForm" class="form-inline" role="form">
        <div class="form-group p-0">
          <label for="" class="formLabel">Client List &nbsp; </label>
          <app-common-dropdown-search *ngIf="clientList.length > 0" [data]="clientList" [addFieldSetting]="addFieldSetting" (callEvent)="ClientListOnChange($event)"></app-common-dropdown-search>
          <!-- <select name="ClientId" class="form-control w-160" [(ngModel)]="ClientId">
            <option [selected]="clientList && clientList.length >1" disabled [value]="null">Select</option>
            <option *ngFor="let c of clientList" [value]="c.Client_Id" [selected]="c.selected">
              {{c.Client_Name}}</option>
          </select> -->
          <button [disabled]="ClientId==null || ClientId.length==0" (click)="getUserList()"
            class="btn blue square-btn blue-hover btn-txt ml-10 btn-default">Search</button>
        </div>
        <div class="form-group p-0 mt-3 flexAuto">
          <label class="formLabel" for="">Agent List - {{userList.length}}</label><br><br>
          <ng-multiselect-dropdown name="userList" [placeholder]="'Select User'" [settings]="fieldSetting" [data]="userList"
            [(ngModel)]="activeUserList" (onSelect)="getEmployee($event)"
            (onDeSelect)="removeEmployee($event)" (onSelectAll)="getEmployee($event)"
            (onDeSelectAll)="removeEmployee($event)">
          </ng-multiselect-dropdown>
        </div>
      </form>

    </div>
    <div class="col-md-9 padding1rem zIndex1 borderRight">
      <div id="reportContainer" class="container-fluid p-0">
        <div id="reportSection">
          <div class="container-fluid p-0">
            <div class="row table-responsive-lg" id="tableContainer">
              <table class="table">
                <thead style="background: #666;">
                  <tr>
                    <th style="width: 5.6% !important;">category</th>
                    <th style="width: 7% !important;left: 16.5%;">queue</th>
                    <th style="width: 21% !important;text-align: left !important;right: 36.5%;">inbox</th>
                    <th style="width: 10% !important;">Record count</th>
                    <th style="width: 7% !important;">HeadCount</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let category of treeData;let categoryIndex=index">
                    <tr class="clientColor">
                      <td class="textAlignLeft">
                        <i title="Expand Client" (click)="toggleNodes(category,'queue')" class="fa"
                          [ngClass]="{'fa-plus' : !category.isExpanded,'fa-minus' : category.isExpanded==true}"></i>
                        {{category.Name || "N/A"}}
                      </td>
                      <td></td>
                      <td></td>
                      <td>
                        {{category.Count || 0}}
                      </td>
                    </tr>
                    <ng-container *ngIf="category.isExpanded==true">
                      <!-- show if Category has queue START-->
                      <ng-container *ngFor="let queue of category.queueList;let queueIndex=index">
                        <tr>
                          <td></td>
                          <td class="textAlignLeft">
                            <i (click)="toggleNodes(queue,'inbox');"
                            (click)="checkUncheckAll($event,queue,category,'inbox')" class="fa"
                            [ngClass]="{'fa-plus' : !queue.isExpanded,'fa-minus' : queue.isExpanded==true}"></i>
                            <label for="checkQ{{categoryIndex}}{{queueIndex}}" class="custom-control queue-conf">
                              <input type="checkbox" id="checkQ{{categoryIndex}}{{queueIndex}}" class="mr-5 mt-0" [(ngModel)]="queue.status" (change)="checkUncheckAll($event,queue,category,'inbox')">
                              <label for="checkQ{{categoryIndex}}{{queueIndex}}" class="label-status">{{queue.Name || "N/A"}}</label>
                            </label>
                          </td>
                          <td></td>
                          <td>
                            {{queue.Count || 0}}
                          </td>
                        </tr>
                        <ng-container *ngIf="queue.isExpanded==true">
                          <tr class="" *ngIf="queue.inboxList && queue.inboxList.length>0">
                            <td>&nbsp;&nbsp;</td>
                            <!-- <td>&nbsp;&nbsp;</td> -->
                            <td>
                              <div class="input-group" style="margin-left: 100px;">
                                <div class="input-group-prepend">
                                  <button class="btn btn-primary searchBtn" type="button">
                                    <i class="fa fa-search"></i>
                                  </button>
                                </div>
                                <input type="text" class="form-control" placeholder="Search Inboxes"
                                  [(ngModel)]="queue.inboxName" (keyup)="matchInbox(queue)">
                                <div class="input-group-append">
                                  <button class="btn btn-primary searchBtn" type="button" (click)="sortInboxData(queue.inboxList) || ascending = !ascending">
                                    <img *ngIf="!queue.inboxList.isSort"  width="15px" src="assets/images/sort-a-to-z.svg" alt="AtoZ" srcset="">
                                    <img *ngIf="queue.inboxList.isSort" width="15px" src="assets/images/sort-z-to-a.svg" alt="ZtoA" srcset="">
                                  </button>
                                </div>
                              </div>

                            </td>
                            <!-- <td></td> -->
                          </tr>
                          <tr>
                            <td>&nbsp;&nbsp;</td>
                            <!-- <td>&nbsp;&nbsp;</td> -->
                            <td colspan="4">

                            <div style="margin-left: 103px;" class="showScroll" *ngIf="queue.inboxList && queue.inboxList.length>0">
                            <ng-container *ngFor="let inbox of queue.inboxList;let inboxIndex=index">
                              <tr *ngIf="inbox.show==null || inbox.show==true" class="widthCss">
                                <td style="min-width: 20px !important;">&nbsp;&nbsp;</td>
                                <!-- <td>&nbsp;&nbsp;</td> -->
                                <td class="textAlignLeft" style="min-width: 523px !important;">
                                  <label for="check{{categoryIndex}}{{queueIndex}}{{inboxIndex}}" class="custom-control queue-conf tooltips">
                                    <input [(ngModel)]="inbox.isSelected" type="checkbox" (change)="isAllSelected($event,queue,category,inbox)"
                                    id="check{{categoryIndex}}{{queueIndex}}{{inboxIndex}}">
                                    <label [title]="inbox.InboxDescription" for="check{{categoryIndex}}{{queueIndex}}{{inboxIndex}}" class="label-status">{{inbox.Name || "N/A"}}</label>

                                  </label>
                                </td>
                                <td style="min-width: 0 !important;">{{inbox.Count || 0}}</td>
                                <td style="min-width: 270px !important;">{{inbox.AssignedAgents}}/{{inbox.TotalAgents}}</td>
                              </tr>
                              <!-- <tr></tr> -->
                            </ng-container>
                          </div>
                          </td></tr>
                          <!-- show  if Queue has no Inboxes START-->
                          <ng-container class="noData" *ngIf="queue && queue.inboxList && queue.inboxList.length==0">
                            <tr class="noData">
                              <td colspan="4">
                                <!-- show if Inbox is fetched by http request START-->
                                <h3 class="fetchingMsg" *ngIf="queue.httpStatus==true">
                                  <i class="fa fa-refresh fa-spin fa-3x"></i>
                                </h3>
                                <!-- show if inbox is not in queue START-->
                                <h3 class="fetchingMsg" *ngIf="queue.httpStatus==false">
                                  <i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i> No Inboxes to show
                                </h3>
                                <!-- show if inbox is not in queue END-->
                              </td>
                            </tr>
                          </ng-container>
                          <!-- show  if Queue has no Inbox END-->
                        </ng-container>



                      </ng-container>
                      <!-- show if Category has Queue END-->

                      <!-- show  if category has no queue START-->
                      <ng-container class="noData" *ngIf="category.queueList && category.queueList.length==0">
                        <tr class="noData">
                          <td colspan="4">
                            <!-- show if queues are fetched by http request START-->
                            <h3 class="fetchingMsg" *ngIf="category.httpStatus==true">
                              <i class="fa fa-refresh fa-spin fa-3x"></i>
                            </h3>

                            <!-- show if queues are fetched by http request END-->

                            <!-- show if queues are not in category START-->
                            <h3 class="fetchingMsg" *ngIf="category.httpStatus==false">
                              <i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i> No Queues to show</h3>
                            <!-- show if manager is not in client END-->
                          </td>
                        </tr>
                      </ng-container>
                      <!-- show  if client has no manager END-->

                    </ng-container>

                  </ng-container>

                  <!-- show  if client has no manager START-->
                  <ng-container class="noData" *ngIf="treeData && treeData.length==0 && httpStatus!=null">
                    <tr class="noData">
                      <td colspan="4">
                        <!-- show if managers is fetched by http request START-->
                        <h3 class="fetchingMsg" *ngIf="httpStatus==true">
                          <i class="fa fa-refresh fa-spin fa-3x"></i>
                        </h3>
                        <!-- <h3 *ngIf="httpStatus==true">Fetching Client report</h3> -->

                        <!-- show if managers is fetched by http request END-->

                        <!-- show if manager is not in client START-->
                        <h3 class="fetchingMsg" *ngIf="httpStatus==false">
                          <i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i>
                          No Categories to show
                        </h3>
                        <!-- show if manager is not in client END-->
                      </td>
                    </tr>
                  </ng-container>
                  <!-- show  if client has no manager END-->

                </tbody>
              </table>
            </div>
            <div class="row mTop20">
              <div class="offset-md-4 col-md-1 p-0">
                <button [disabled]="!storeCheckedData.length || !storeConcatIdCode.length" class="btn blue square-btn blue-hover btn-txt btn-default" (click)="mapEmployeeCategory()">Map</button>
              </div>
              <div class="col-md-2 p-0">
                <button [disabled]="!storeCheckedData.length || !storeConcatIdCode.length" class="btn blue square-btn blue-hover btn-txt btn-default" (click)="isDeallocate = true">De-Allocate</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="pop-bg" *ngIf="isDeallocate"></div>
<div id="confirm" class="modal-show" *ngIf="isDeallocate">
  <div class="modal-body">
    Do you want to De-Allocate?
  </div>
  <div class="modal-footer">
    <button type="button" class="btn blue square-btn blue-hover btn-txt btn-default" id="delete" (click)="isDeallocate = false">No</button>
    <button type="button" class="btn blue square-btn blue-hover btn-txt btn-default" (click)="deallocateEmployeeCategory()">Yes</button>
  </div>
</div>
